// extracted by mini-css-extract-plugin
module.exports = {"root":"Info_root__3KZ9W","requiredAsterisk":"Info_requiredAsterisk__3eIgb"};